/*
 * Remplace le <h2 class="kl_reviews__summary__header"> injecte par l'app
 * Klaviyo Reviews par un <span> equivalent (memes attributs, meme contenu).
 *
 * Objectif SEO : ce titre n'est pas un vrai titre de section (deja couvert
 * par le h1/h2 de la page), on evite donc un h2 supplementaire dans le DOM.
 *
 * Le widget est injecte / mis a jour de facon asynchrone par l'app Klaviyo,
 * on observe donc le DOM en continu.
 */
(function () {
  var SELECTOR = 'h2.kl_reviews__summary__header';

  function replaceWithSpan(heading) {
    var span = document.createElement('span');

    for (var i = 0; i < heading.attributes.length; i++) {
      var attr = heading.attributes[i];
      span.setAttribute(attr.name, attr.value);
    }

    while (heading.firstChild) {
      span.appendChild(heading.firstChild);
    }

    heading.replaceWith(span);
  }

  function evaluateAll() {
    document.querySelectorAll(SELECTOR).forEach(replaceWithSpan);
  }

  function init() {
    evaluateAll();

    // subtree + childList : detecte le h2 quand il est insere dans le DOM.
    // attributes + attributeFilter: ['class'] : detecte le cas ou Klaviyo pose
    // la classe kl_reviews__summary__header sur un h2 deja present (post-render).
    var observer = new MutationObserver(evaluateAll);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });

    // Filet de securite : l'app peut re-render son widget sans mutation
    // detectable immediatement (fetch API des avis parfois lent). On garde un
    // polling peu couteux en continu plutot qu'une fenetre de temps limitee.
    setInterval(evaluateAll, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

